module.exports = __webpack_public_path__ + "static/media/icon-p-delete.4ccb5e1e.svg";